import React, { FunctionComponent } from "react"
import { useTranslation } from "react-i18next"

import ConfirmModal from "components/ConfirmModal/ConfirmModal"
import Text from "components/Text/Text"

export interface ICopyAssetWarningModalProps {
    count: number
    sourceLmid: string
    onConfirm(): void
    onGoBack(): void
}

/** Confirmation shown before the copies are actually created. */
const CopyAssetWarningModal: FunctionComponent<React.PropsWithChildren<ICopyAssetWarningModalProps>> = ({
    count,
    sourceLmid,
    onConfirm,
    onGoBack,
}) => {
    const { t } = useTranslation()

    return (
        <ConfirmModal
            title={t('copyAsset.copyAsset')}
            maxWidth="560px"
            cancelButtonLabel={t('copyAsset.goBack')}
            confirmButtonLabel={t('copyAsset.createCopies', { count })}
            onClose={onGoBack}
            onConfirm={onConfirm}>
            <Text type="p">{t('copyAsset.warningText', { count, lmid: sourceLmid })}</Text>
        </ConfirmModal>
    )
}

export default CopyAssetWarningModal
